import Model from '../../model/model';





export default Model.extend( {

    endpoint: 'users/tag?apiVersion=2.0',

} );


// WEBPACK FOOTER //
// ./src/js/model/refbooks/user.tag.js